import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasViewed.meta';

export type UseTrackCanvasViewedParams = {
  canvas_id: string;
  viewer_role: 'owner' | 'workspace_member' | 'anonymous';
  board_id?: string;
  viewed_from?: 'board' | 'recent_canvases' | 'my_canvases' | 'all_canvases' | 'shared_link';
};

export const useTrackCanvasViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasViewed = useCallback(
    (params: UseTrackCanvasViewedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasViewed };
};
